import ih from 'immutability-helper';

import createPaginatedListReducerWithNamedType from 'store/hoReducers/paginatedList/reducer';
import initialState from './initialState';

import { PURGE_ACTIONS } from '../project/actionTypes';
import { SELECT_ENTITY } from '../entities/actionTypes';

import {
  ADD_ENTITY_FEATURE_SUCCESS,
  UPDATE_ENTITY_FEATURE_SUCCESS,
  DELETE_ENTITY_FEATURE_SUCCESS,
} from './actionTypes';

const reducerHandlers = (state = initialState, action = {}) => ({
  // Reset reducer when entity is changed
  [SELECT_ENTITY]: () => ih(state, { $set: initialState }),
  [PURGE_ACTIONS]: () => ({
    ...state,
    list: {
      ...state.list,
      data: {
        ...state.list.data,
        items: state.list.data.items.filter(
          o => !action.payload.data.entity_features.includes(o.id),
        ),
      },
    },
  }),
  [ADD_ENTITY_FEATURE_SUCCESS]: () =>
    ih(state, {
      add: {
        isLoading: { $set: false },
      },
    }),
  [UPDATE_ENTITY_FEATURE_SUCCESS]: () =>
    ih(state, {
      update: {
        isLoading: { $set: false },
      },
    }),
  [DELETE_ENTITY_FEATURE_SUCCESS]: () =>
    ih(state, {
      delete: {
        isLoading: { $set: false },
      },
    }),
});

export default createPaginatedListReducerWithNamedType(
  'ENTITY_FEATURE',
  initialState,
  reducerHandlers,
);
